import * as React from 'react';
import { WizardNavBar } from 'sos-common/js/components/WizardStepper/WizardNavBar/WizardNavBar';
import { WizardPagination } from 'sos-common/js/components/WizardStepper/WizardPagination/WizardPagination';
import { StepState } from 'sos-common/js/components/WizardStepper/WizardStepper.types';
import StepService from '../../services/step.service';
import EventService from '../CalculationComponents/calculationComponents.eventservice';

export interface StatsbidragWizardStepWrapperProps {
  steps: StepState[];
  renderPagination?: boolean;
}

export interface StatsbidragWizardStepWrapperState {
  currentStep: number;
  steps: StepState[];
}

/**
 * Handles step change logic and view state (white buttons, green buttons) according to the validation results.
 * The validation results are coming as an event, this component does not handle validation by itslf.
 */
export class StatsbidragWizardStepWrapper extends React.Component<
  StatsbidragWizardStepWrapperProps,
  StatsbidragWizardStepWrapperState
> {
  constructor(props: StatsbidragWizardStepWrapperProps) {
    super(props);
    this.state = {
      currentStep: 0,
      steps: props.steps,
    };
  }

  componentDidMount() {
    EventService.subscribe('step-changed', (e: CustomEvent) => {
      this.setState({
        currentStep: e.detail,
      });
    });

    EventService.subscribe('step-is-validated', (e: CustomEvent) => {
      const { step, stepIsValid } = e.detail;
      let stepStateClone = this.state.steps.slice();
      stepStateClone[step].isDone = stepIsValid;
      this.setState({
        steps: stepStateClone,
      });
    });
  }

  onStepChange = (step: number) => {
    StepService.goToStep(step);
  };

  public render() {
    const { renderPagination } = this.props;
    const { currentStep, steps } = this.state;
    return (
      <React.Fragment>
        {!renderPagination && <WizardNavBar steps={steps} currentStep={currentStep} goToStep={this.onStepChange} />}
        {renderPagination && (
          <WizardPagination
            steps={steps}
            previousLabel="Föregående"
            nextLabel="Nästa"
            currentStep={currentStep}
            goToStep={this.onStepChange}
          />
        )}
      </React.Fragment>
    );
  }
}
